import type { EditFgtsModalFormProps } from './types'

export const initialFormValues: EditFgtsModalFormProps = {
  value: ''
}
